const messages = {
    // branding
    'branding.name': 'WatchESPN',
    // meta
    'meta.keywords': 'watchespn, watch espn, watchespn mobile, watchespn xbox live, live sports, watch live sports, ' +
    'watch espn online, watch espn on xbox, watch espn on mobile phone, espn, espn2, espn3, espnu',
    'meta.title.home': 'WatchESPN: Live Sports, Game Replays, Video Highlights',
    'meta.description.home': 'Stream live sports, watch game replays, get video highlights, and access featured ESPN ' +
    'content on your computer, mobile device, and TV on ESPN.com and the ESPN app.',
    'meta.title.schedule': 'Schedule: Live, Upcoming, Replays - WatchESPN',
    'meta.description.schedule': 'Get live, upcoming, and replay schedule information for your favorite sports and shows ' +
    'across every ESPN network on WatchESPN.',
    'meta.title.features': 'Featured Videos - WatchESPN',
    'meta.description.features': 'Watch featured news clips, game highlights, and special ESPN programming on WatchESPN.',
    'meta.title.collection': '{name} - WatchESPN',
    'meta.description.collection': 'Watch videos from the {name} collection on WatchESPN.',
    'meta.title.player': '{name} - WatchESPN',
    'meta.description.player.vod': 'Watch the {name} video on WatchESPN.',
    'meta.description.player.listing': 'Watch {name} on WatchESPN.',
    'meta.title.activate': 'Activate - WatchESPN',
    'meta.description.activate': 'Activate your device',
    'meta.title.subscribe': 'Subscribe - WatchESPN',
    'meta.description.subscribe': 'Subscribe your device',
    'meta.title.feedback': 'Provide Feedback - WatchESPN',
    'meta.description.feedback': 'Provide feedback on WatchESPN, the service that provides full access on your computer, mobile devices and Xbox Live to all live sports events, replays and programs on the ESPN networks.',
    // page
    'page.bucket.header.seeAll': "See All",
    // schedule
    'schedule.header': 'Schedule',
    'schedule.live': 'Live Now',
    'schedule.live.selectedTabError': 'live',
    'schedule.upcoming': 'Upcoming',
    'schedule.upcoming.selectedTabError': 'upcoming',
    'schedule.replay': 'Replay',
    'schedule.replay.selectedTabError': 'replay',
    'schedule.allSports': 'All Sports',
    'schedule.allNetworks': 'All Networks',
    'schedule.allLeagues': 'All Leagues',
    'schedule.replay.all': 'All',
    'schedule.replay.today': 'Today',
    'schedule.replay.last7Days': 'Last 7 days',
    'schedule.replay.last14Days': 'Last 14 days',
    'schedule.replay.last30Days': 'Last 30 days',
    'schedule.blackout': 'Subject to blackout',
    'schedule.message.empty': 'There are currently no {selectedTab} events for this selection.{br}Please check {otherTabs1} or {otherTabs2} or clear all filters.',
    // schedule module
    'schedule.module.header.live': 'Top Live',
    'schedule.module.header.upcoming': 'Upcoming',
    'schedule.module.header.upcoming.on': 'Upcoming on',
    'schedule.module.alert.upcoming': '{name} is scheduled to begin at {startTime} on {source}. {moreText}',
    'schedule.module.alert.moreText': 'Please enjoy {name} while you wait.',
    'schedule.module.eventDate.tomorrow': 'Tomorrow',
    // calendar months
    'schedule.calendar.month.January': 'January',
    'schedule.calendar.month.February': 'February',
    'schedule.calendar.month.March': 'March',
    'schedule.calendar.month.April': 'April',
    'schedule.calendar.month.May': 'May',
    'schedule.calendar.month.June': 'June',
    'schedule.calendar.month.July': 'July',
    'schedule.calendar.month.August': 'August',
    'schedule.calendar.month.September': 'September',
    'schedule.calendar.month.October': 'October',
    'schedule.calendar.month.November': 'November',
    'schedule.calendar.month.December': 'December',
    // calendar short days
    'schedule.calendar.day.Mon': 'MON',
    'schedule.calendar.day.Tue': 'TUE',
    'schedule.calendar.day.Wed': 'WED',
    'schedule.calendar.day.Thu': 'THU',
    'schedule.calendar.day.Fri': 'FRI',
    'schedule.calendar.day.Sat': 'SAT',
    'schedule.calendar.day.Sun': 'SUN',
    // calendar long days
    'schedule.calendar.day.Monday': 'Monday',
    'schedule.calendar.day.Tuesday': 'Tuesday',
    'schedule.calendar.day.Wednesday': 'Wednesday',
    'schedule.calendar.day.Thursday': 'Thursday',
    'schedule.calendar.day.Friday': 'Friday',
    'schedule.calendar.day.Saturday': 'Saturday',
    'schedule.calendar.day.Sunday': 'Sunday',
    // search
    'search.placeholder': 'Find your team, event, or show...',
    'search.results.message': 'Search results for {query}',
    // player
    'player.error.defaultMessage': 'This network is not included in your current television subscription. Please contact your provider to upgrade.',
    'player.error.recommendMobileWeb': 'The device is unable to play this video within the app.  Please try visiting espn.com/watch with the latest version of your browser on this device.',
    'player.error.unexpectedMessage': 'An unexpected error occurred during authorization. Please refresh the page to try again.',
    'player.menu.logout': 'Log Out of {providerName}',
    'player.feeds.title': 'Choose Broadcast',
    // provider dialog
    'search.filter.placeholder': 'Search All Providers',
    'provider.dialog.title': 'Choose Provider',
    'provider.dialog.subtitle': 'All Providers (A-Z):',
    'provider.dialog.description': 'Stream ESPN now by signing in with your TV provider. Having trouble? Check {faq} or {help}.',
    'provider.dialog.description.noCost': 'no additional cost',
    'provider.dialog.button.text': 'Get A TV Provider',
    'provider.dialog.faq.label': 'FAQs',
    'provider.dialog.help.link': 'http://www.espninstantaccess.com/',
    'provider.dialog.help.label': 'Get Help',
    'provider.dialog.call': '888-549-ESPN',
    // sign out
    'signout.message': 'Do you want to sign out of your {providerName} account?',
    'signout.label': 'Sign Out',
    // feedback
    'feedback.title': 'Don\'t want to chat? Submit feedback via email.',
    'feedback.caption': 'Provide your e-mail address if you\'d like us to follow up with you directly.',
    'feedback.category': 'Choose Category',
    'feedback.category.select': 'Select a category',
    'feedback.category.userExperience': 'User Experience',
    'feedback.category.videoPerformance': 'Video Performance',
    'feedback.category.programming': 'Programming',
    'feedback.category.other': 'Other',
    'feedback.email': 'E-mail',
    'feedback.provider': 'Cable / Internet Providers',
    'feedback.provider.default': 'Choose Provider',
    'feedback.platform': 'Platform',
    'feedback.desktoplaptop': 'Desktop/laptop',
    'feedback.iphone': 'iPhone',
    'feedback.ipad': 'iPad',
    'feedback.androidphone': 'Android Phone',
    'feedback.androidtablet': 'Android Tablet',
    'feedback.xbox': 'Xbox One',
    'feedback.playstation': 'PlayStation',
    'feedback.appletv': 'Apple TV',
    'feedback.androidtv': 'Android TV',
    'feedback.amazonfiretv': 'Amazon FireTV',
    'feedback.chromecast': 'Chromecast',
    'feedback.roku': 'Roku',
    'feedback.comments': 'Comments',
    'feedback.send': 'Send feedback',
    'feedback.thankYou': 'Thank you for posting your feedback.',
    'feedback.error.category': 'Please select a type of issue.',
    'feedback.error.email': 'Please enter your e-mail address.',
    'feedback.error.comments': 'Please enter your comment.',
    // misc
    'live': 'LIVE',
    'blackout': 'Blackout',
    // espnapp
    'espnapp.systemAlert.upcoming': 'This event has not started yet. Tune in at {time} to watch.',
    // syndicated player
    'syndicated.player.dialog': 'Live programming on WatchESPN is available for no additional cost from selected television and broadcast providers. Please choose your provider from the list below to sign in and see the ESPN networks you can watch:',
    'syndicated.player.dialog.label.continute': 'Continue',
    'syndicated.player.dialog.label.recheck': 'Recheck access',
    'syndicated.player.dialog.message.auth-success': 'You are logged in, playback will start shortly.',
    'syndicated.player.dialog.message.auth-retry': 'If playback does not begin in 5 seconds, please refresh your browser. This may take up to a minute.',
    'syndicated.player.dialog.message.xdomain': 'Your browser appears to block storing data that\'s required for the playback, change your browser setting to allow storing 3rd party data.',
    'syndicated.player.branding.tooltip': 'View this video on {brandingName}',
    'syndicated.player.domain.error': 'You are not allowed to access WatchESPN from this website. Please visit WatchESPN.com to see if you have access to this game.',
    'syndicated.player.message.upcoming': 'This event has not started yet. Please check back once the event has begun.',
    'syndicated.player.message.no-events': 'No events available.',
    'syndicated.player.message.geo': 'This video is not currently available to view in your location.',
    // unsupported error due to possible COUNTRY_AND_EDITION_CONFLICT Page API Error
    'unsupported.error.message': 'This content is not available in this country.'
};

export default messages;



// WEBPACK FOOTER //
// ./app/lib/i18n/en-us.js